export default __webpack_public_path__ + "ac7b319eadb60d26a19ee3fe69de87af.png";